// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"V5-z"};